import angular from 'angular';

export const moduleName = 'noUiSlider';
export const module = angular.module(moduleName, []);
